<template>
  <BasicLayout :left='left' :middle='middle' :right='right'>
    <template v-slot:right_view>
      <div id='trackTable' class='h100vh-100'>
        <TsMenuButton ref='tsMenuButton' @methodEnum='methodEnum' @keywords='changeKeywords' :keywordsInput='true'></TsMenuButton>
        <OnlineTimeTable ref='onlineTimeTable' @refresh='refresh'></OnlineTimeTable>
      </div>
    </template>
  </BasicLayout>
</template>

<script>
import BasicLayout from '../../layouts/BasicLayout';
import TsMenuButton from '../../components/tsConfig/TsMenuButton';
import OnlineTimeTable from '../../components/tsConfig/OnlineTimeStatistics/OnlineTimeTable';

export default {
  name: 'OnlineTimeStatisticsPage',
  components: {
    BasicLayout,
    TsMenuButton,
    OnlineTimeTable
  },
  data() {
    return {
      left: {
        show: false,
        name: ''
      },
      middle: {
        show: false,
        name: ''
      },
      right: {
        show: true,
        crumb: `${this.$t('TS.trafficMeasurement')}/${this.$t('TS.onlineTimeStatistics')}`
      }
    };
  },
  methods: {
    changeKeywords(args) {
      this.$refs.onlineTimeTable.keywords = args;
      this.$refs.onlineTimeTable.pageSettings.currentPage = 1;
      this.$refs.onlineTimeTable.searchNum();
    },
    refresh(args) {
      this.$refs.tsMenuButton.queryConditions.keywords = '';
    },
    methodEnum(opcode) {
      switch (opcode) {
        case 'search':
          this.$refs.onlineTimeTable.searchPage();
          break;
        default:
      }
    }
  }
};
</script>

<style scoped>

</style>
